import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import { Grid, GridColumn as Column, GridCell } from '@progress/kendo-react-grid';
import { fetchApi } from '../../services/api';

type Props = RouteComponentProps<{
    accountId: string;
 }>;

type State = {
    accountId: number;
    agreements: Agreement[];
    isLoading: boolean;
}

export interface Agreement {
    AgreementId: number;
    AgreementVersion: number;
    Date: Date;
    Title: Number;
}

class AgreementTitleCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={ `/agreement/${this.props.dataItem.AgreementId}/${this.props.dataItem.AgreementVersion}` }>
                    {this.props.dataItem.Title}
                </Link>
            </td>
        );
    }
}

class DateCell extends GridCell {
    render() {
        if (!this.props.field) return null;

        return (
            <td>{moment.utc(this.props.dataItem[this.props.field]).local().format("YYYY-MM-DD")}</td>
        );
    }
}

export default class AccountAgreements extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            accountId: 0,
            agreements: [],
            isLoading: false,
        };

        this.getAgreements = this.getAgreements.bind(this)
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let accountId = parseInt(this.props.match.params.accountId) || 0;
        this.getAgreements(accountId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let accountId = parseInt(nextProps.match.params.accountId) || 0;

        if (this.state.agreements && this.state.accountId != accountId) {
            this.getAgreements(accountId);
        }
    }

    public render() {
        return <div>
            <br />
            <Grid data={this.state.agreements} scrollable='none'>
                <Column field="Agreement" cell={AgreementTitleCell} />
                <Column field="Date" title="Signed" cell={DateCell} filter="date" />
            </Grid>
        </div>;
    }

    private getAgreements(accountId: number) {
        this.setState({ isLoading: true, accountId });
        fetchApi(`api/Account/Agreements/${accountId}`)
            .then((agreements: Agreement[]) => {
                this.setState({ agreements });
            })
            .finally(() => {
                this.setState({ isLoading: false });
            })
    }
}
